import { IsEnum, IsInt, IsOptional, Max, Min } from 'class-validator';
import { Type } from 'class-transformer';
import { OrderEnum } from '../../enums';

export class PageOptionsDto {
	@IsEnum(OrderEnum)
	@IsOptional()
	readonly order?: OrderEnum = OrderEnum.ASC;

	@IsOptional()
	readonly orderField?: string;

	@Type(() => Number)
	@IsInt()
	@Min(1)
	@IsOptional()
	readonly page: number = 1;

	@Type(() => Number)
	@IsInt()
	@Min(1)
	@Max(50)
	@IsOptional()
	readonly manualTake: number;

	get take(): number {
		return this.manualTake ? this.manualTake : this.page === 1 ? 20 : 10;
	}

	get skip(): number {
		return this.page === 1 ? 0 : (this.page - 2) * this.take + 20;
	}
}
